export const filterSelect = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'red' : '#1b2A2E',
        backgroundColor: state.isFocused ? '#00a2ff' : 'transparent',
        padding: 5,
        fontFamily: 'Cairo',
        fontSize: '1.4rem'
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: 'rgba(0, 162, 255, .7)',
        borderRadius: '.5rem',
        paddingLeft: '.4rem'
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        borderRadius: '.5rem'
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1b2A2E'
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.4rem'
    }),
    control: (provided, state) => ({
        ...provided,
        boxShadow: state.isFocused ? '0 0 0 1px #00a2ff' : '',
        borderColor: state.isFocused ? '#00a2ff' : '#888B8B',
        outlineColor: state.isFocused ? '#00a2ff' : '#888B8B',
        borderRadius: '1rem',
        '&:hover': { outlineColor: state.isFocused ? '#00a2ff' : '#888B8B', }
    }),
    placeholder: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.6rem'
    }),
}

export const dogSelect = {
    container: (provided) => ({
        ...provided,
        width: '100%',
        marginBottom: '1rem'
    }),

    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'red' : '#1b2A2E',
        backgroundColor: state.isFocused ? '#00a2ff' : 'transparent',
        padding: 5,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1b2A2E'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    control: (provided, state) => ({
        ...provided,
        paddingLeft: '2rem',
        borderRadius: '0',
        height: '5rem',
        boxShadow: state.isFocused ? '0 0 0 1px #00a2ff' : '',
        borderColor: state.isFocused ? '#00a2ff' : '#F2F1F1',
        outlineColor: state.isFocused ? '#00a2ff' : '#F2F1F1',
        backgroundColor: state.isFocused ? '#ffffff' : '#F2F1F1',
        '&:hover': { outlineColor: state.isFocused ? '#00a2ff' : '#F2F1F1', }
    }),
    placeholder: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
}
export const dogSelectInvalid = {
    container: (provided) => ({
        ...provided,
        width: '100%',
    }),

    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#00a2ff' : '#1b2A2E',
        backgroundColor: state.isFocused ? '#00a2ff' : 'transparent',
        padding: 5,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1b2A2E'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    control: (provided, state) => ({
        ...provided,
        paddingLeft: '2rem',
        borderRadius: '0',
        height: '5rem',
        boxShadow: state.isFocused ? '0 0 0 1px #E90101' : '',
        borderColor: state.isFocused ? '#E90101' : '#E90101',
        outlineColor: state.isFocused ? '#E90101' : '#E90101',
        backgroundColor: state.isFocused ? '#ffffff' : '#F2F1F1',
        '&:hover': { outlineColor: state.isFocused ? '#E90101' : '#E90101', }
    }),
    placeholder: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
}


export const dogSelectDark = {
    container: (provided) => ({
        ...provided,
        width: '100%',
        marginBottom: '1rem'
    }),

    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#00a2ff' : '#ffffff',
        backgroundColor: state.isFocused ? '#00a2ff' : 'transparent',
        padding: 5,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#162447'
    }),
    menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#ffffff'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem',
        color: '#ffffff'
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    control: (provided, state) => ({
        ...provided,
        paddingLeft: '2rem',
        borderRadius: '0',
        height: '5rem',
        boxShadow: state.isFocused ? '0 0 0 1px #00a2ff' : '',
        borderColor: state.isFocused ? '#00a2ff' : '#162447',
        outlineColor: state.isFocused ? '#00a2ff' : '#162447',
        backgroundColor: state.isFocused ? '#162447' : '#162447',
        '&:hover': { outlineColor: state.isFocused ? '#00a2ff' : '#162447', }
    }),
    placeholder: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
}
export const dogSelectInvalidDark = {
    container: (provided) => ({
        ...provided,
        width: '100%',
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#162447'
    }),
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'red' : '#ffffff',
        backgroundColor: state.isFocused ? '#00a2ff' : 'transparent',
        padding: 5,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#ffffff'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem',
        color: '#ffffff'
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
    control: (provided, state) => ({
        ...provided,
        paddingLeft: '2rem',
        borderRadius: '0',
        height: '5rem',
        boxShadow: state.isFocused ? '0 0 0 1px #E90101' : '',
        borderColor: state.isFocused ? '#E90101' : '#E90101',
        outlineColor: state.isFocused ? '#E90101' : '#E90101',
        backgroundColor: state.isFocused ? '#ffffff' : '#162447',
        '&:hover': { outlineColor: state.isFocused ? '#E90101' : '#E90101', }
    }),
    placeholder: (provided) => ({
        ...provided,
        fontFamily: 'Cairo',
        fontSize: '1.2rem'
    }),
}